import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  wellnessDashboard: 'Wellness Dashboard',
  sustainabilityDashboard : 'Sustainability Dashboard',
  usageReporting: 'Usage reporting',
};
